import React from 'react';
import './ApiError.scss';

export const ApiError = ({ message }) => (
  <div className="api-error">{message ? message : '서버와의 처리 과정에서 에러가 발생했습니다.'}</div>
);
